export default __webpack_public_path__ + "static/media/logo.a6cf86c7.gif";